// extracted by mini-css-extract-plugin
module.exports = {"page_section":"ContentContainer_page_section__1PATM","page_content":"ContentContainer_page_content__2iWK1"};